import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsList = (props: PropsWithChildren) => {
  const { children } = props;

  return <View style={styles.list}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  list: {
    gap: theme.spacing['2'],
  },
});
